import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { initKuaishouQuery } from './utils/kuaishouQuery'
import { sharedSocket } from '@/websocketV2'

import 'swiper/css/swiper.min.css'

Vue.config.productionTip = false
Vue.prototype.$websocket = sharedSocket
// 初始化快手渠道 query 共享（跨子域名）
initKuaishouQuery()
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
